import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SlimLoadingBarService } from 'ng2-slim-loading-bar';
import swal from 'sweetalert2';
import { ProjectsService } from '../../services/projects/projects.service';
import { LeadsService } from '../../services/lead-service/lead-service.service';
import { UserServiceService } from '../../services/user-service/user-service.service';
import { ErrorHandlerService } from '../../services/shared/error-handler.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-ambassadors',
  templateUrl: './ambassadors.component.html',
  styleUrls: ['./ambassadors.component.css'],
})
export class AmbassadorsComponent implements OnInit {
  readonly ambassadorDetailFields = [
    { key: 'name', label: 'Ambassador Name' },
    { key: 'contact_person', label: 'Contact Person' },
    { key: 'contact_phone', label: 'Contact Phone' },
    { key: 'contact_address', label: 'Contact Address' },
  ];

  ambassador_export_url: any;

  ambassadorsListAll: any[] = [];
  ambassadorsList: any[] = [];
  ambassadorsLoading = false;

  selectedAmbassador: any;
  filterOpen = false;
  filterForm: FormGroup;

  activeTab: 'activity' | 'documents' | 'commissions' = 'activity';
  ambassadorDocuments: any[] = [];
  documentsLoading = false;

  ambassadorDocumentForm: FormGroup;
  ambassadorToUploadDocumentId: any;
  @ViewChild('documentFile') documentFile: any;

  ambassadorCommissionData: any = {};
  projects: Array<any> = [];
  commissionsLoading = false;

  agents: any[] = [];

  uploadExcel: FormGroup;

  activityLogsMock: any[] = [];

  constructor(
    private slimLoadingBarService: SlimLoadingBarService,
    private fb: FormBuilder,
    private userService: UserServiceService,
    private leadService: LeadsService,
    private projectService: ProjectsService,
    private errorHandlerService: ErrorHandlerService,
    private router: Router
  ) {}

  ngOnInit() {
    this.ambassador_export_url = `${environment.api_base_url}ambassadors/export?token=${window.localStorage.getItem('token')}`;
    this.createFilter();
    this.getAmbassadors();
    this.getAgents();
    this.getprojects();

    this.ambassadorDocumentForm = this.fb.group({
      file: [null, Validators.required],
      name: [null],
    });

    this.uploadExcel = this.fb.group({
      file: [null, Validators.required],
    });
  }

  createFilter() {
    this.filterForm = this.fb.group({ q: '' });
  }

  getAmbassadors(reset = false) {
    if (reset) {
      this.ambassadorsListAll = [];
      this.ambassadorsList = [];
    }

    this.ambassadorsLoading = true;
    this.slimLoadingBarService.start();

    this.userService.getAmbasdors({ paginate: false }).subscribe(
      (data: any) => {
        this.slimLoadingBarService.complete();
        this.ambassadorsListAll = (data || []).map((a) => {
          if (!a.agent) { a.agent = { name: '', id: '' }; }
          return a;
        });
        this.applyClientFilters();
        this.ambassadorsLoading = false;
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.ambassadorsLoading = false;
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  applyClientFilters() {
    const fv = this.filterForm.value || {};
    const q = (fv.q || '').toString().trim().toLowerCase();
    let list = [...(this.ambassadorsListAll || [])];

    if (q) {
      list = list.filter((a) => {
        const name = ((a && a.name) || '').toString().toLowerCase();
        const phone = ((a && a.contact_phone) || '').toString().toLowerCase();
        const address = ((a && a.contact_address) || '').toString().toLowerCase();
        const agent = ((a && a.agent && a.agent.name) || '').toString().toLowerCase();
        return name.includes(q) || phone.includes(q) || address.includes(q) || agent.includes(q);
      });
    }

    this.ambassadorsList = list;
  }

  getAgents() {
    this.leadService.getPropertyConsultant().subscribe(
      (res: any) => { this.agents = res || []; },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  getprojects() {
    this.projectService.getProjects({ is_select_form: true }).subscribe(
      (data: any) => {
        const projectsArray = data.data || data || [];
        this.ambassadorCommissionData = projectsArray.reduce((obj, project) => {
          obj[project.id] = { value: 0, commision_id: null };
          return obj;
        }, {});
        this.projects = projectsArray;
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  resetCommissions() {
    this.ambassadorCommissionData = (this.projects || []).reduce((obj, project) => {
      obj[project.id] = { value: 0, commision_id: null };
      return obj;
    }, {});
  }

  selectAmbassador(ambassador: any) {
    this.activeTab = 'activity';
    this.selectedAmbassador = Object.assign({}, ambassador);
  }

  setActiveTab(tab: 'activity' | 'documents' | 'commissions') {
    this.activeTab = tab;
    if (tab === 'documents') { this.loadSelectedAmbassadorDocuments(); }
    if (tab === 'commissions') { this.loadSelectedAmbassadorCommissions(); }
  }

  loadSelectedAmbassadorDocuments() {
    if (!this.selectedAmbassador) { return; }
    this.documentsLoading = true;
    this.userService.getAmbassadorDocuments(this.selectedAmbassador.id).subscribe(
      (res) => {
        this.ambassadorDocuments = res as any;
        this.documentsLoading = false;
      },
      (err) => {
        this.documentsLoading = false;
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  loadSelectedAmbassadorCommissions() {
    if (!this.selectedAmbassador) { return; }
    this.resetCommissions();
    this.commissionsLoading = true;
    this.userService.getAmbassadorCommissions(this.selectedAmbassador.id).subscribe(
      (data: any) => {
        (data || []).forEach((d) => {
          if (this.ambassadorCommissionData[d.project_id]) {
            this.ambassadorCommissionData[d.project_id].value = d.commission;
            this.ambassadorCommissionData[d.project_id].commission_id = d.id;
          }
        });
        this.commissionsLoading = false;
      },
      (err) => {
        this.commissionsLoading = false;
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  saveCommissions() {
    if (!this.selectedAmbassador) { return; }
    const payload = {
      commissions: (this.projects || []).map((proj) => ({
        project_id: proj.id,
        commission: (this.ambassadorCommissionData && this.ambassadorCommissionData[proj.id] && this.ambassadorCommissionData[proj.id].value) || 0,
      })),
    };
    this.userService.updateAmbassadorCommissions(this.selectedAmbassador.id, payload).subscribe(
      () => swal('Success', 'Commissions saved successfully', 'success'),
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  sendToErp(ambassador: any) {
    swal({
      title: 'Are you sure?',
      text: 'This will send the ambassador to ERP. This action cannot be undone.',
      type: 'warning',
      showCancelButton: true,
      cancelButtonText: 'No',
      confirmButtonText: 'Yes, Send',
      confirmButtonColor: '#3085d6',
    }).then((res) => {
      if (res.value) {
        this.userService.sendAmbassadorToErp(ambassador.id).subscribe(
          () => swal('Success', 'Ambassador sent to ERP successfully', 'success'),
          (err) => this.errorHandlerService.handleErorr(err)
        );
      }
    });
  }

  editAmbassador(ambassador: any) {
    window.localStorage.setItem('edit_ambassador_settings', JSON.stringify(ambassador));
    this.router.navigateByUrl('/pages/ambassadors/add');
  }

  deleteAmbassador(id: any) {
    swal({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this ambassador!',
      type: 'warning',
      showCancelButton: true,
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
      confirmButtonColor: '#d33',
    }).then((res) => {
      if (res.value) {
        this.slimLoadingBarService.start();
        this.userService.deleteAmbassador(id).subscribe(
          () => {
            swal('Success', 'Ambassador deleted successfully', 'success');
            this.slimLoadingBarService.complete();
            this.selectedAmbassador = null;
            this.getAmbassadors(true);
          },
          (err) => {
            this.slimLoadingBarService.reset();
            this.errorHandlerService.handleErorr(err);
          }
        );
      } else if (res.dismiss) {
        swal('Cancelled', '', 'error');
      }
    });
  }

  uploadAmbassadorDocumentModalOpen(ambassador: any) {
    this.ambassadorToUploadDocumentId = ambassador && ambassador.id;
  }

  uploadAmbassadorDocumentModalClose() {
    this.ambassadorDocumentForm.reset();
    if (this.documentFile && this.documentFile.nativeElement) {
      this.documentFile.nativeElement.value = '';
    }
  }

  uploadAmbassadorDocument(modal: any) {
    const payload = { documents: this.ambassadorDocumentForm.get('file').value };
    this.userService.uploadAmbassadorDocument(this.ambassadorToUploadDocumentId, payload as any).subscribe(
      () => {
        swal('Success', 'Document uploaded successfully', 'success');
        this.ambassadorDocumentForm.reset();
        modal.close();
        this.loadSelectedAmbassadorDocuments();
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  handleDocumentUpload(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      const files = this.handleFormatMultiple(event.target.files);
      this.ambassadorDocumentForm.get('file').setValue(files);
    }
  }

  handleFormatMultiple(filesArray: any) {
    const files = Object.values(filesArray);
    const filesBase46 = [];
    for (let i = 0; i < files.length; i++) {
      const img: any = files[i];
      const reader = new FileReader();
      reader.readAsDataURL(img);
      reader.onload = () => {
        filesBase46.push({
          document_name: img.name,
          document_value: (reader.result as any).split(',')[1],
        });
      };
    }
    return filesBase46;
  }

  deleteAmbassadorDocument(ambassadorId: any, documentId: any) {
    this.userService.deleteAmbassadorDocument(ambassadorId, documentId).subscribe(
      () => { this.loadSelectedAmbassadorDocuments(); },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  handleUploadExcel(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.uploadExcel.get('file').setValue({
          file_name: file.name,
          file_value: (reader.result as any).split(',')[1],
        });
      };
    }
  }

  uploadExcelMethod(modal: any) {
    const formValue = this.uploadExcel.value;
    const data = {
      file_name: formValue.file.file_name,
      file: formValue.file.file_value,
    };
    this.slimLoadingBarService.start();
    this.leadService.importAmbassadors(data).subscribe(
      () => {
        this.uploadExcel.reset();
        modal.close();
        swal('Success', 'Ambassadors imported successfully', 'success');
        this.getAmbassadors(true);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  filter() {
    this.filterOpen = false;
    this.applyClientFilters();
  }

  resetFilter() {
    this.filterOpen = false;
    this.createFilter();
    this.applyClientFilters();
  }

  getAmbassadorFieldValue(ambassador: any, key: string): string {
    if (!ambassador) { return '—'; }
    if (key === 'contact_person') {
      return (ambassador.agent && ambassador.agent.name) || '—';
    }
    return ambassador[key] || '—';
  }
}



// WEBPACK FOOTER //
// ./src/app/main-settings/ambassadors/ambassadors.component.ts